import { Components } from '@mui/material';

export const getMuiFormControlLabel =
  (): Components['MuiFormControlLabel'] => ({
    styleOverrides: {
      root: {
        margin: 0,
      },
    },
  });
